import { mapPrice, mapReducedPrice } from "../mapPrice";
import { mapBadgeType } from "./mapBadge";
import { getHasMoreColours } from "./getHasMoreColours";
import { getIsSponsored } from "./getIsSponsored";
import { addRecsRequestIdToUrl } from "./addRecsRequestIdToUrl";

const getRecommendationsRequestId = ({ product, recommendationsAnalytics }) => {
  const { requestId, items } = recommendationsAnalytics ?? {};

  return requestId && items?.includes(product.id) ? requestId : undefined;
};

export const mapProduct = ({ product, recommendationsAnalytics }) => {
  const price = mapPrice(product.price);
  const reducedPrice = mapReducedPrice(product.price);
  const hasMoreColours = getHasMoreColours({
    facetGroupings: product.facetGroupings,
  });
  const recommendationsRequestId = getRecommendationsRequestId({
    product,
    recommendationsAnalytics,
  });

  let advertisement = {
    id: product.advertisement?.id,
    variantId: product.advertisement?.variantId,
  };

  if (CLIENT && product.advertisement) {
    advertisement = product.advertisement;
  }

  return {
    id: product.id,
    productCode: product.productCode,
    url: recommendationsRequestId
      ? addRecsRequestIdToUrl(product.url, recommendationsRequestId)
      : product.url,
    price,
    description: product.name,
    image: product.imageUrl,
    badgeType: mapBadgeType({ ...product, hasMoreColours }),
    productType: product.productType,
    colourWayId: product.colourWayId,
    isSale: product.price.isMarkedDown,
    reducedPrice,
    hasMultiplePrices: product.hasMultiplePrices,
    isOutlet: product.price.isOutletPrice,
    isSellingFast: product.isSellingFast,
    brandName: product.brandName,
    colour: product.colour,
    hasMoreColours,
    discounted: product.price.discounted,
    priceLocalCurrency: reducedPrice || price,
    isSponsored: getIsSponsored(product.advertisement),
    isRestockingSoon: product.isRestockingSoon,
    advertId: product.advertisement?.id,
    advertisement,
    additionalImageUrls: product.additionalImageUrls,
    videoUrl: product.videoUrl,
    showVideo: product.showVideo,
    earlyAccess: product.earlyAccess,
    ...(recommendationsRequestId && { recommendationsRequestId }),
  };
};

export default mapProduct;
